import { StorySection } from '../../services';
import { StoryTabType } from '../models';

export const getStorySectionByTabType = (storyTabType?: StoryTabType) => {
  switch (storyTabType) {
    case StoryTabType.storyTab1:
      return [StorySection.MIX_LIST];
    case StoryTabType.storyTab2:
      return [StorySection.MIX_LIST_2];
    case StoryTabType.storyTab3:
      return [StorySection.MIX_LIST_3];
    case StoryTabType.storyTab4:
      return [StorySection.MIX_LIST_4];
    case StoryTabType.storyTab5:
      return [StorySection.MIX_LIST_5];
    case StoryTabType.pinnedStoryTab:
      return [StorySection.PINNED];
    default:
      return;
  }
};
